import React, {type PropsWithChildren} from 'react';
import Box, {type BoxProps} from '@mui/material/Box';

import {useListMediaQuery, type ListBreakpoint} from './use-list-media-query';
import {ClassNames} from './shared';

export type ListItemProps = {
    /**
     * @default 'tabletPortrait'
     */
    displayFrom?: ListBreakpoint;

    textAlign?: BoxProps['textAlign'];

    onClick?: React.MouseEventHandler<HTMLDivElement>;
};

export const ListItem = ({
    displayFrom = 'tabletPortrait',
    textAlign,
    onClick,
    children,
}: PropsWithChildren<ListItemProps>) => {
    const isVisible = useListMediaQuery(displayFrom);

    return (
        <Box
            className={ClassNames.ListItem}
            display={isVisible ? 'inline-flex' : 'none'}
            textAlign={textAlign}
            onClick={onClick}
        >
            {children}
        </Box>
    );
};
